<template>

                <v-img
                    :lazy-src="data.image.sizes.thumbnail"
                    lazy
                    :src="data.image.sizes.full"
                    cover
                    fetchpriority="low"
                    :gradient="(data.gradient) ? gradientColor[data.gradient] : null"
                    :alt="data.image.title+' - '+data.image.description"
                    :class="data.class"
                    :max-width="(data.maxWidth) ? data.maxWidth : '100%'"
                    :min-height="(data.minHeight) ? data.minHeight : '300px'"
                ></v-img>
            
</template>

<script>
export default{
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    data: () => ({
    gradientColor:{
        black: "to bottom, rgba(0,0,0,1), rgba(33,33,33,1), rgba(33,33,33,0.51), rgba(0,0,0,0.31), rgba(0,0,0,0.1), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.0), rgba(0,0,0,0.2),  rgba(18,18,18,0.51), rgba(18,18,18,1), rgba(0,0,0,1)",
        white: "to bottom, rgba(255,255,255,1), rgba(255,255,255,1), rgba(255,255,255,0.51), rgba(255,255,255,0.31), rgba(255,255,255,0.1), rgba(255,255,255,0.0), rgba(255,255,255,0.0), rgba(255,255,255,0.2),  rgba(255,255,255,0.51), rgba(255,255,255,1)",
        primary: "to bottom, rgba(179,148,127,1), rgba(179,148,127,1), rgba(179,148,127,0.51), rgba(179,148,127,0.31), rgba(179,148,127,0.1), rgba(179,148,127,0.0), rgba(179,148,127,0.0), rgba(179,148,127,0.2),  rgba(179,148,127,0.51), rgba(179,148,127,1)"
    }})
}
</script>